import { createSelector } from 'reselect';

const pike13Selector = state => state.pike13;

export const selectPike13Data = createSelector(pike13Selector, pike13 => {
  const { locations = [], services = [] } = pike13 || {};
  return {
    ...pike13,
    services,
    locations: locations.map(({ id, name, address }) => ({
      id,
      label: `${name}, ${address || '[no address]'}`,
    })),
  };
});
